
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction, createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { editConnectionSalesTypes, deleteConnectionSalesTypes } from 'state/connection-sales-types/actions';

const openModal = createOpenModalAction('EditSalesTypesModal');
const closeModal = createCloseModalAction('EditSalesTypesModal');

export const startMappingSalesTypes = (salesTypeId, edits) => dispatch => {
    dispatch({
        type: actions.START_MAPPING_SALES_TYPES,
        payload: { salesTypeId, edits }
    })
    dispatch(editConnectionSalesTypes(salesTypeId, edits));
    dispatch(openModal());
}

export const stopMappingSalesTypes = () => dispatch => {
    dispatch({
        type: actions.STOP_MAPPING_SALES_TYPES
    })
    dispatch(closeModal());
}

export const deleteMappingSalesTypes = (salesTypeId) => dispatch => {
    dispatch({
        type: actions.DELETE_MAPPING_SALES_TYPES,
        payload: { salesTypeId }
    })
    dispatch(deleteConnectionSalesTypes(salesTypeId));
    //props.successNotice('Deleted');
}
